export default __webpack_public_path__ + "static/media/icon-lightbulb-outline.e52a498f.svg";